<template>
  <v-container fluid class="city-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-city`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-home-city</v-icon>
            City
          </v-tab>
          <v-tab-item
            :value="'tab-city'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit City</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'citycode')"
                        v-bind:value="initvalue.citycode"
                        placeholder="City Code"
                        persistent-hint
                        single-line hint="Enter the city code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'cityname')"
                        v-bind:value="initvalue.cityname"
                        placeholder="City Name"
                        persistent-hint
                        single-line hint="Enter the city name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=citytype
                        :value="initvalue.citytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'citytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the city type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="countries.map(x => {
                            return {text: x.countryname, value: x._id};
                          })"
                        :value="initvalue.countryid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'countryid')"
                        placeholder="Country"
                        persistent-hint
                        single-line hint="Please choose the country">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'citystatus')"
                          v-bind:label="initvalue.citystatus"
                          v-model="initvalue.citystatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/city/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCity()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      city: {},
      detail: {},
      photo: {},
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      citytype: ['District', 'City'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions('City', ['updateCityRequest','getCitiesRequest']),
    editCity() {
      this.city._id = this.initvalue._id;
      this.updateCityRequest(this.city);
      this.getCitiesRequest();
      router.push('/city/list');
    },
    updateChangedValue(value, field){
      this.city[field] = value;
    },
  },
  computed: {
    ...mapState('Country', ['countries']),
    ...mapState('City', ['isReceiving']),
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'CityList' });
    if(this.countries.length==0) this.getCountriesRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
